export default {
    game_id: "turbo_27_dice",
    gameName : "Turbo 27 Dice",

    stageWidth: 1280,
    stageHeight: 720,

    scripts: [
        'framework/src/vendor/jquery.min.js',
        'framework/src/vendor/tween.js',
        'framework/src/vendor/ph.js',
    ],
    ["wallet"]: {
        ["creditBets"]: {
            ["$default"]: [1, 2, 3, 4, 5, 6, 7, 8, 9, 10]
        },

        ["defaultCreditBet"]: {
            ["$default"]: 1
        },

        ["denominations"]: {
            ["$default"]: [0.1, 0.25, 0.5, 1, 1.25, 2.5]
        }
    },

    game: {
        unfinishedRoundDelay: 1000,
        audio: {
            tracks: []
        },
        freespins: {
            autostart: true
        },
    },
    system: {
		audio: {
			tracks: [
{
    name: 'Jackpot_sound',
    classVol: 'volume.normalWin',
    loop: false,
},
{
    name: 'JokerBonus_alert',
    classVol: 'volume.normalWin',
    loop: false,
},]
        }
    }
}